import { convertToYears } from "utils";

import {
  filterDateRangeReducerAction,
  filterDateRangeReducerState,
  ENUM_FilterDateRangeActionType,
} from "./filterDateRage.types";

const formatFilterDates = (
  payload: any
): { startDate: string; endDate: string } => {
  return {
    startDate: payload[0] ? convertToYears(payload[0]) : "",
    endDate: payload[1] ? convertToYears(payload[1]) : "",
  };
};

export const filterDateRangeInitialValue: filterDateRangeReducerState = {
  filterDates: [],
  formatedFilterDates: {
    startDate: "",
    endDate: convertToYears(new Date()),
  },
};

export const filterDateRangeReducer = (
  state: filterDateRangeReducerState,
  action: filterDateRangeReducerAction
) => {
  switch (action.type) {
    case ENUM_FilterDateRangeActionType.UPDATEDATES:
      return {
        filterDates: action.payload,
        formatedFilterDates: formatFilterDates(action.payload),
      };
    case ENUM_FilterDateRangeActionType.FILTERDATES:
      return {
        ...filterDateRangeInitialValue,
      };
    default:
      return state;
  }
};
